import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../../../CommonComponents/BreadCrumb/BreadCrumb";
import UsersListing from "./UsersListing";
import DataPerPage from "../../../CommonComponents/Pagination/DataPerPage";
import "../admin.css";

const Users = () => {
    const [dataPerPage, setDataPerPage] = useState(10)
    const [selectAction, setSelectAction] = useState('action')
    const [totalData, setTotalData] = useState(0)
    const [searchTerm, setSearchTerm] = useState('')

    const handleChange = (e) => {
        const val = e.target.value;
        setSearchTerm(val);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') setSearchTerm(e.target.value);
    }

    return (
        <>
            <div className="admin-module">
                <div className="admin-user-page admin-content">
                    <Breadcrumb string="Admin / Users" />

                    <div className="container admin-user-container">
                        <div className=" mb-4 show-select1 d-flex admin-user-header">
                            <div className="admin-user-controls admin-user-search-group">
                                <DataPerPage dataPerPage={dataPerPage} setDataPerPage={setDataPerPage} />
                                <div className="admin-user-search-input-wrap">
                                    <div className="Search-inp">
                                        <div>
                                            <input
                                                value={searchTerm}
                                                onChange={handleChange}
                                                onKeyDown={handleKeyDown}
                                                placeholder="Search here"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="admin-user-search-btn"
                                    aria-label="Search"
                                    onClick={() => setSearchTerm(searchTerm)}
                                >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                            </div>

                            <div className="admin-user-action-dropdown">
                                <select
                                    id="user-action-select"
                                    className="admin-user-select"
                                    onChange={(e) => setSelectAction(e.target.value)}
                                    value={selectAction}
                                    aria-label="Select action for users"
                                >
                                    <option value="action">Select Action</option>
                                    <option value="delete">Delete Selected</option>
                                    <option value="sendMail">Resend Signup Verification</option>
                                    <option value="bulkDomain">Assign Domains</option>
                                </select>
                            </div>
                        </div>

                        <UsersListing
                            dataPerPage={dataPerPage}
                            selectAction={selectAction}
                            setSelectAction={setSelectAction}
                            onTotalDataChange={setTotalData}
                            searchTerm={searchTerm}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Users;
